module.exports = __webpack_public_path__ + "media/images/new/filter_by_reported_cell_service_laptop-4dbb2a377286f1a1bafb9fe15cafd7c5.png";